import * as angular from "angular";
import {IController} from "angular";
import {GroupModel} from "../../models/group.model";
import {GroupColor} from "../../constants/group-color";

export class AddBranchesToGroupComponent implements IController {

  isCreateNewGroup: boolean;
  createGroup: GroupModel;
  selectedGroupToMoveToId: string;
  onToggleIsCreateButton: Function;
  onCreateGroupChange: Function;

  public groupColors: string[] = GroupColor;

  onTagsChange(ids: string[]) {
    this.createGroup.tags = ids;
    this.onCreateGroupChange({createGroup: this.createGroup});
  }

  onGroupColorSelect(event, color) {
    this.createGroup.displayColor = color;
    this.onCreateGroupChange({createGroup: this.createGroup});
  }
}


angular
  .module('bringoz.admin.groups')
  .component('addBranchesToGroup', {
    require: {
      form: '^form'
    },
    bindings: {
      isCreateNewGroup: '<',
      createGroup: '<',
      selectedGroupToMoveToId: '<',
      onToggleIsCreateButton: '&',
      onGroupIdChange: '&',
      onCreateGroupChange: '&'
    },
    template: require('./add-branches-to-group.html').default,
    controller: AddBranchesToGroupComponent
  });
